// src/React/src/components/chat/ChatBubble.tsx
import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { ChatMessage } from '../../actions/agentQueryActions'

interface Props {
  message: ChatMessage
}

// Defined outside component to maintain stable reference across renders.
const markdownComponents: Components = {
  h1: ({ children }) => <h5>{children}</h5>,
  h2: ({ children }) => <h5>{children}</h5>,
  h3: ({ children }) => <h5>{children}</h5>,
  h4: ({ children }) => <h6>{children}</h6>,
  h5: ({ children }) => <h6>{children}</h6>,
  h6: ({ children }) => <h6>{children}</h6>,
  table: ({ children }) => (
    <div style={{ overflowX: 'auto' }}>
      <table className="table table-sm table-bordered">{children}</table>
    </div>
  ),
  thead: ({ children }) => <thead className="table-light">{children}</thead>,
  hr: () => <hr className="my-2" />,
  a: ({ href, children }) => {
    const safe = href && /^https?:\/\//.test(href) ? href : null
    if (!safe) return <>{children}</>
    return <a href={safe} target="_blank" rel="noopener noreferrer">{children}</a>
  },
}

const bubbleStyle = (role: ChatMessage['role']): React.CSSProperties => {
  if (role === 'user') {
    return {
      alignSelf: 'flex-end',
      backgroundColor: '#0d6efd',
      color: '#fff',
      borderRadius: '18px 18px 4px 18px',
    }
  }
  if (role === 'error') {
    return {
      alignSelf: 'flex-start',
      backgroundColor: '#fff0f0',
      color: '#dc3545',
      borderRadius: '18px 18px 18px 4px',
    }
  }
  return {
    alignSelf: 'flex-start',
    backgroundColor: '#f0f0f0',
    color: '#212529',
    borderRadius: '18px 18px 18px 4px',
  }
}

const ChatBubble: React.FC<Props> = ({ message }) => {
  const isAgent = message.role === 'agent'
  return (
    <div
      style={{
        ...bubbleStyle(message.role),
        maxWidth: isAgent ? '85%' : '70%',
        padding: '8px 14px',
        marginBottom: '6px',
        wordBreak: 'break-word',
        ...(isAgent ? {} : { whiteSpace: 'pre-wrap' }),
      }}
    >
      {isAgent ? (
        <ReactMarkdown components={markdownComponents} remarkPlugins={[remarkGfm]}>
          {message.text}
        </ReactMarkdown>
      ) : (
        message.text
      )}
    </div>
  )
}

export default ChatBubble
